import { render, staticRenderFns } from "./ShippingTerms.vue?vue&type=template&id=48db3bb3&scoped=true&"
import script from "./ShippingTerms.vue?vue&type=script&lang=js&"
export * from "./ShippingTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db3bb3",
  null
  
)

export default component.exports